import { useContext } from 'react';

import { SseEngineContext } from './SseEngineContextValue';

export const useSseEngineContext = () => useContext(SseEngineContext);
